export const trackingAcceptedCookie = "_vwbtracking-accepted";
export const hasAcceptedValue = "accepted";
export const popupCookie = "_vwbpopup-closed";
export const hasClosedPopup = "closed";
export const hasSubmittedPopup = "submitted";

export function GetTrackingCookieName() {

return GetCookieName(trackingAcceptedCookie);

 


}

export function TrackingAccepted() {
  
    return getCookie(GetTrackingCookieName()) === hasAcceptedValue;
  
  
}

export function GetPopupCookieName() {

  return GetCookieName(popupCookie);

}

export function GetCookieName(cookieName="") {

  if(window.location.href.includes("mysite.vagaro.com")){
    let split = window.location.pathname.split("/");
    if(split.length > 1){
      return  cookieName+split[1]+cookieName;
    }
   
  }
  else{
    return cookieName + window.location.hostname;
  }

  
  return cookieName +window.location.hostname;

 


}

export function getCookie(cname) {
  let name = cname + "=";
  try{
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
  }
  catch(e){
    console.error(e);
  }
  return "";
}



  export function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }